export default __webpack_public_path__ + "resources/icons/d222-44df.webp";